<template>
  <div class="flex flex-col h-screen w-80 bg-white text-gray-900 border border-gray-300">
    <div class="flex items-center justify-center py-4 text-gray-800 font-bold text-xl">
      Админ панель
    </div>
    <nav class="flex-grow px-4 mt-4">
      <template v-if="isLoading">
        <p>Загрузка...</p>
      </template>
      <template v-else>
        <SidebarItem
          v-for="item in filteredMenuItems"
          :key="item.name"
          :item="item"
        />
      </template>
    </nav>
  </div>
</template>

<script>
import { fetchUserPermissions } from "@/services/userService";
import SidebarItem from "./SidebarItem.vue";

export default {
  name: "AppSidebar",
  components: { SidebarItem },
  data() {
    return {
      isLoading: true,
      menuItems: [
        { name: "Главная", icon: "fas fa-th-large", requiredPermission: "view_dashboard" },
        { name: "Роли", icon: "fas fa-user-shield", requiredPermission: "manage_users" },
        { name: "Заявки", icon: "fas fa-user-shield", requiredPermission: "view_reports" },
        { name: "Оценки", icon: "fas fa-user-shield", requiredPermission: "manage_roles" },
        { name: "Бухгалтерия", icon: "fas fa-user-shield", requiredPermission: "view_accounting" },
         { name: "Новости", icon: "fas fa-user-shield", requiredPermission: "view_accounting" },
        { name: "Клиники AI", icon: "fas fa-user-shield", requiredPermission: "view_accounting" },
        { name: "Аналитика", icon: "fas fa-user-shield", requiredPermission: "view_accounting" },
         { name: "Аналитика плагина", icon: "fas fa-chart-bar", requiredPermission: "view_accounting" },
        { name: "Аналитика стационара", icon: "fas fa-hospital", requiredPermission: "view_accounting" },
        { name: "Клиники", icon: "fas fa-user-shield", requiredPermission: "view_accounting" },
        { name: "Уведомления", icon: "fas fa-user-shield", requiredPermission: "view_notify" },
        { name: "Тех поддержка", icon: "fas fa-user-shield", requiredPermission: "view_notify" },
        { name: "Партнеры", icon: "fas fa-user-shield", requiredPermission: "view_all_partner" },
      ],
    };
  },
  computed: {
    filteredMenuItems() {
      return this.menuItems.filter(item => this.hasPermission(item.requiredPermission));
    },
  },
  methods: {
    hasPermission(permission) {
      if (!permission) return true;

      const userPermissions = JSON.parse(localStorage.getItem("userPermissions") || "[]");
      return userPermissions.includes(permission);
    },
    async loadPermissions() {
      try {
        const permissions = await fetchUserPermissions();
        localStorage.setItem("userPermissions", JSON.stringify(permissions));
      } catch (error) {
        console.error("Ошибка при загрузке разрешений пользователя:", error);
      } finally {
        this.isLoading = false; // Завершаем загрузку
      }
    },
  },
  async created() {
    await this.loadPermissions(); // Загрузка разрешений при монтировании
  },
};
</script>

<style scoped>
/* Добавьте любой дополнительный стиль, если нужно */
</style>
